import React from 'react';
import HighlightedProduct from './HighlightedProduct';

// Componente combinado: buscador, producto destacado y lista de productos
const ProductSearchPanel = ({
    searchTerm,
    setSearchTerm,
    onSearchKeyDown,
    inputRef,
    cart,
    getDiscountedPrice,
    filteredProducts,
    onAddToCart,
    getPrice,
    selectedIndex = -1
}) => {
    return (
        <div className="sticky top-0 z-40 bg-white border-b shadow-lg">
            <div className="w-full max-w-2xl mx-auto flex flex-col gap-1 px-2 pt-2 pb-2">
                {/* Buscador */}
                <div className="w-full">
                    <input
                        ref={inputRef}
                        type="text"
                        autoFocus
                        placeholder="Buscar producto..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        onKeyDown={onSearchKeyDown}
                        className="w-full p-2 md:p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-blue-500 text-sm md:text-base bg-white"
                        style={{ minWidth: 0 }}
                    />
                </div>

                {/* Lista de productos filtrados */}
                {searchTerm && filteredProducts.length > 0 && (
                    <div className="bg-white shadow-md rounded-lg max-h-60 md:max-h-80 overflow-y-auto mt-2 md:mt-4">
                        <ul>
                            {filteredProducts.map((product, index) => {
                                const hasStock = product.stock_unidades > 0;
                                const isSelected = index === selectedIndex;
                                return (
                                    <li
                                        key={product.id}
                                        className={`py-2 px-3 md:px-4 border-b flex justify-between items-center text-sm md:text-base transition-all
                      ${isSelected
                                                ? 'bg-blue-100 border-blue-300'
                                                : hasStock
                                                    ? 'hover:bg-gray-100 cursor-pointer'
                                                    : 'bg-gray-100 cursor-not-allowed opacity-60'
                                            } ${isSelected && hasStock ? 'cursor-pointer' : ''}`}
                                        onClick={() => hasStock && onAddToCart(product)}
                                    >
                                        <div className="flex flex-col flex-1 min-w-0">
                                            <span className={`font-medium truncate ${!hasStock ? 'text-gray-500' : ''}`}>
                                                {product.nombre_producto}
                                                {!hasStock && <span className="ml-2 text-xs text-red-500 font-normal">(Sin stock)</span>}
                                            </span>
                                            {/* Mostrar códigos de barra */}
                                            {Array.isArray(product.codigo_barras) && product.codigo_barras.length > 0 ? (
                                                <div className={`text-xs ${hasStock ? 'text-gray-500' : 'text-gray-400'}`}>
                                                    {product.codigo_barras.slice(0, 2).map((cb, i) => (
                                                        <span key={i} className="block truncate">
                                                            {cb.codigo}
                                                        </span>
                                                    ))}
                                                    {product.codigo_barras.length > 2 && (
                                                        <span className="text-xs text-gray-400">+{product.codigo_barras.length - 2} más</span>
                                                    )}
                                                </div>
                                            ) : product.codigo_barras?.codigo ? (
                                                <div className={`text-xs truncate ${hasStock ? 'text-gray-500' : 'text-gray-400'}`}>
                                                    {product.codigo_barras.codigo}
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="flex flex-col items-end ml-2">
                                            <div className={`text-xs font-medium mb-1 ${hasStock
                                                    ? (product.stock_unidades <= 5 ? 'text-orange-600' : 'text-blue-600')
                                                    : 'text-red-600'
                                                }`}>
                                                Stock: {product.stock_unidades}
                                            </div>
                                            {product.tieneDescuento ? (
                                                <>
                                                    <span className={`line-through text-xs md:text-sm ${hasStock ? 'text-gray-500' : 'text-gray-400'}`}>
                                                        ${product.precios[0].precio}
                                                    </span>
                                                    <span className={`font-bold text-sm md:text-base ${hasStock ? 'text-green-700' : 'text-gray-500'}`}>
                                                        ${product.precioFinal}
                                                    </span>
                                                </>
                                            ) : (
                                                <span className={`font-bold text-sm md:text-base ${hasStock ? 'text-green-700' : 'text-gray-500'}`}>
                                                    ${getPrice(product)}
                                                </span>
                                            )}
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}

                {/* Producto destacado */}
                {cart.length > 0 && (
                    <div className="flex flex-col items-center justify-center w-full bg-blue-50 rounded-lg mt-1 mb-0.5 p-2 md:p-3 shadow">
                        <div className="text-base md:text-5xl font-semibold text-gray-800 truncate w-full text-center">
                            {cart[cart.length - 1].nombre_producto}
                        </div>
                        <div className="text-xl md:text-5xl font-bold text-green-700 text-center">
                            ${getDiscountedPrice(cart[cart.length - 1])}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductSearchPanel;